import React from 'react';
import { curry, startsWith, assoc, isNil, isEmpty, map, prop } from 'ramda';
export var wrapAncor = function wrapAncor(linkConfig) {
  return React.createElement('a', linkConfig, linkConfig.title);
};
export var wrapDomain = curry(function (domain, linkConfig) {
  if (startsWith('tel:', linkConfig.href)) {
    return linkConfig;
  }

  return assoc('href', '' + domain + linkConfig.href, linkConfig);
});
export var appendQuery = curry(function (queryString, linkConfig) {
  if (isNil(queryString) || isEmpty(queryString)) {
    return linkConfig;
  }

  if (startsWith('tel:', linkConfig.href)) {
    return linkConfig;
  }

  return assoc('href', linkConfig.href + '/?' + queryString, linkConfig);
});
export var toKebabCase = function toKebabCase(str) {
  return str && str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g).map(function (x) {
    return x.toLowerCase();
  }).join('-');
};
export var convertLinkGroup = curry(function (f, linkGroup) {
  var links = linkGroup.links;
  var convertedLinks = map(f, links);
  return assoc('links', convertedLinks, linkGroup);
});
export var wrapAssetPath = curry(function (options, path) {
  if (typeof path !== 'string') return path;

  if (options.wrapAssetPath === false || path.startsWith('data:')) {
    return path;
  }

  var startsWithSlash = startsWith('/', path);

  if (startsWithSlash) {
    return path;
  }

  return '/' + path;
});
export var resolveIcon = function resolveIcon(theme, icon) {
  if (isNil(theme)) {
    return;
  }

  var iconPath = prop(icon, theme.iconsForCssUrls);

  if (isNil(iconPath) || isEmpty(iconPath)) {
    return;
  }

  return iconPath;
};
export var hexify = function hexify(color) {
  var hex = color.replace(/^\s*#|\s*$/g, '');
  return hex.length == 3 ? hex.replace(/(.)/g, '$1$1') : hex;
};
export var adjust = function adjust(color, percent) {
  var hex = hexify(color),
      num = parseInt(hex, 16),
      amt = Math.round(2.55 * percent),
      R = (num >> 16) + amt,
      B = (num >> 8 & 0x00FF) + amt,
      G = (num & 0x0000FF) + amt;
  return '#' + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + (B < 255 ? B < 1 ? 0 : B : 255) * 0x100 + (G < 255 ? G < 1 ? 0 : G : 255)).toString(16).slice(1);
};
export var gradient = function gradient(deg, start, end) {
  return 'linear-gradient(' + deg + 'deg, ' + start + ' 0%, ' + end + ' 100%);';
};